var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { authAPIConfig } from "./auth/index.js";
import { publicAPIConfig } from "./public/index.js";
import { siteAPIConfig } from "./site/index.js";
import { createApi } from "../external/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
const _APIClient = class _APIClient {
  constructor(config) {
    __publicField(this, "baseQuery");
    __publicField(this, "_apiConfigs");
    __publicField(this, "_reducers", {});
    __publicField(this, "_middlewares", []);
    this.baseQuery = config.baseQuery;
    this._apiConfigs = {
      auth: authAPIConfig,
      site: siteAPIConfig,
      public: publicAPIConfig
    };
  }
  createApis() {
    const authAPI = createApi({
      ...authAPIConfig,
      baseQuery: this.baseQuery.auth
    });
    const siteAPI = createApi({
      ...siteAPIConfig,
      baseQuery: this.baseQuery.site
    });
    const publicAPI = createApi({
      ...publicAPIConfig,
      baseQuery: this.baseQuery.public
    });
    const middlewares = [];
    if (authAPI) {
      middlewares.push(authAPI.middleware);
    }
    if (siteAPI) {
      middlewares.push(siteAPI.middleware);
    }
    if (publicAPI) {
      middlewares.push(publicAPI.middleware);
    }
    this._middlewares = middlewares;
    const reducers = {};
    if (authAPI) {
      reducers[authAPI.reducerPath] = authAPI.reducer;
    }
    if (siteAPI) {
      reducers[siteAPI.reducerPath] = siteAPI.reducer;
    }
    if (publicAPI) {
      reducers[publicAPI.reducerPath] = publicAPI.reducer;
    }
    this._reducers = reducers;
    return {
      auth: authAPI,
      site: siteAPI,
      public: publicAPI
    };
  }
  //
  static getInstance(config) {
    if (!this.instance) {
      this.instance = new _APIClient(config);
    }
    return this.instance;
  }
  apiConfigs() {
    return this._apiConfigs;
  }
  reducers() {
    return this._reducers;
  }
  middlewares() {
    return this._middlewares;
  }
};
__publicField(_APIClient, "instance");
let APIClient = _APIClient;
const APIClient$1 = APIClient;
export {
  APIClient$1 as default
};
